import { DocPage, Section, SpecTable } from "../../components/DocChrome";

export function AuditPage() {
    return (
        <DocPage
            title="Consistency Audit"
            description="Hallmark perfection pass status across Workspace packages and panels."
        >
            <Section title="Resolved in Hallmark perfection pass">
                <SpecTable
                    rows={[
                        ["Button Framer scale hover/tap", "Removed — plain button, zero motion"],
                        ["Card hover translate", "Removed — zero motion"],
                        [
                            "Button icon API",
                            "Adopted on high-traffic CTAs in Rider, Customer, Tenant, Owner",
                        ],
                        [
                            "Shared UI in @maeiz/ui",
                            "Elevated PageHeader, StatCard, ActionMenu, ConfirmModal, FormDialog, Pill, AuthShell, PaginationBar, GlobalLoader",
                        ],
                        ["Radix overlays", "DropdownMenu, Popover, Accordion, Combobox"],
                        ["Banner + DateField", "Shipped in @maeiz/ui"],
                        ["Tooltip scale pop", "Opacity only"],
                        ["Table loading", "Skeleton components"],
                        [
                            "Sora/Outfit fonts",
                            "Removed from Rider/Customer; unified on Montserrat + Roboto + JetBrains Mono",
                        ],
                        [
                            "Token Hex cleanup",
                            "Hardcoded hex purged from app CSS & JSX; unified on @maeiz/tokens (#C9A736 canonical gold)",
                        ],
                    ]}
                />
            </Section>
            <Section title="Open / follow-up">
                <SpecTable rows={[["P3", "Command palette when product requires it"]]} />
            </Section>
        </DocPage>
    );
}
